const investmentTypeOngletLang = {
	synthesis: {
		tag: 'investment.type.onglet.synthesis',
		fr: 'Synthèse',
		en: 'Synthesis',
	},

	funds_portfolio: {
		tag: 'investment.type.onglet.funds_portfolio',
		fr: 'Portefeuille',
		en: 'Portfolio funds',
	},
	funds_assets: {
		tag: 'investment.type.onglet.funds_assets',
		fr: 'Actifs',
		en: 'Assets',
	},
	funds: {
		tag: 'investment.type.onglet.funds',
		fr: 'Cantons / fonds',
		en: 'Portfolio / funds',
	},
	history: {
		tag: 'investment.type.onglet.history',
		fr: 'Historique',
		en: 'History',
	},
};

export default investmentTypeOngletLang;
